export const IMAGE_WIDTH = 50;
export const IMAGE_HEIGHT = 50;
export const SLIDE_MARGIN = 16;
export const VIDEO_TYPE = 'video';
export const IMAGE_TYPE = 'image';
export const BUTTON = 'button';
export const PRODUCT_DESCRIPTION = 'productDescriptionWrapper';
export const PRODUCT_SELECTED_IMAGE = 'productSelectedImage';
export const PRODUCT_IMAGE_MAGNIFY = 'pd-image-magnifier-container';
export const IFRAME_ID = 'productVideoIFrame';
export const SLIDE_IMAGES_CLASSNAME = 'slide-view-container';
export const THUMBNAIL_SLIDE_CLASSNAME = 'slide-view-thumbnail';
export const VIDEO_SLIDE_CLASSNAME = 'slide-related-video';
export const PRODUCT_VIDEO_PLAYED = 'productVideoPlay';
export const VIDEO_SWITCHES = {
    VIDEOS: 'Videos',
    IMAGES: 'Images',
};
export const VIDEO_POSITION = {
    PDP: 'pdp',
    FULL_SCREEN: 'fullScreen',
};
export const PDP_VIDEO_POPUP_OPEN = 'pdpVideoPopupOpen';
export const PDP_IMAGE_POPUP_OPEN = 'pdpImagePopupOpen';
